(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,6251,3696,9956,5051],{

/***/ 16726:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(77490);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30730);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_badge_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53218);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69626);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93587);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67330);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__);







function Badge(param) {
    let { type , variant ="default" , size ="medium"  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    switch(type){
        case "bonus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bonus), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("bonus")
                    })
                ]
            });
        case "discount":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().discount), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 20
                })
            });
        case "popular":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popular), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("popular")
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
    }
}


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadMore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88700);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42041);



function LoadMore(param) {
    let { children , onClick , loading =false , size ="large"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loadMore), " ").concat(size === "small" ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().small) : (_button_module_scss__WEBPACK_IMPORTED_MODULE_1___default().large)),
        disabled: loading,
        onClick: onClick,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: 21
        }) : children
    });
}


/***/ }),

/***/ 791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42041);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88700);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 9956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Empty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55684);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_empty_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(791);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21867);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @next/next/no-img-element */ 




function Empty(param) {
    let { text , buttonText , link ="/"  } = param;
    const { push  } = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/delivery.webp",
                    alt: "Empty"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                    children: text
                }),
                !!buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().actions),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: ()=>push(link),
                        children: buttonText
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 25627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79963);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86430);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 10299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74549);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5125);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66750);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8854);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 85794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ WEEK; }
/* harmony export */ });
const WEEK = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
];


/***/ }),

/***/ 93696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ShopCategoryList; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(52709);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/categoryCard/v1.module.scss
var v1_module = __webpack_require__(14363);
var v1_module_default = /*#__PURE__*/__webpack_require__.n(v1_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/image.js
var next_image = __webpack_require__(86430);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(21867);
;// CONCATENATED MODULE: ./components/categoryCard/v1.tsx






function CategoryCard(param) {
    let { data  } = param;
    var ref, ref1;
    const { query  } = (0,router.useRouter)();
    const handleQuery = (categoryId)=>{
        if (Number(query === null || query === void 0 ? void 0 : query.category_id) === categoryId) {
            return {
                ...query,
                category_id: undefined
            };
        }
        return {
            ...query,
            category_id: categoryId
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            query: handleQuery(data === null || data === void 0 ? void 0 : data.id)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((v1_module_default()).card, " ").concat(Number(query === null || query === void 0 ? void 0 : query.category_id) === (data === null || data === void 0 ? void 0 : data.id) ? (v1_module_default()).active : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    width: 30,
                    height: 30,
                    className: (v1_module_default()).img,
                    alt: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    src: (data === null || data === void 0 ? void 0 : data.img) || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (v1_module_default()).text,
                    children: data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(59164);
// EXTERNAL MODULE: ./containers/shopCategoryList/v1.module.scss
var shopCategoryList_v1_module = __webpack_require__(36956);
var shopCategoryList_v1_module_default = /*#__PURE__*/__webpack_require__.n(shopCategoryList_v1_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(53440);
;// CONCATENATED MODULE: ./containers/shopCategoryList/v1.tsx









function ShopCategoryList(param) {
    let { data , loading , parent  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shopCategoryList_v1_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (shopCategoryList_v1_module_default()).title,
                children: t("categories")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: !loading && (data === null || data === void 0 ? void 0 : data.length) === 0 ? "none" : "block",
                    background: "var(primary-bg)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    className: "full-width",
                    modules: [
                        swiper_esm/* Navigation */.W_
                    ],
                    navigation: true,
                    slidesPerView: "auto",
                    spaceBetween: 10,
                    children: [
                        !!parent && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            style: {
                                maxWidth: "max-content"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/shop-category/".concat(parent),
                                shallow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shopCategoryList_v1_module_default()).card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (shopCategoryList_v1_module_default()).text,
                                        children: t("all")
                                    })
                                })
                            })
                        }),
                        loading ? Array.from(Array(10).keys()).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (shopCategoryList_v1_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    className: (shopCategoryList_v1_module_default()).shimmer
                                })
                            }, item)) : data === null || data === void 0 ? void 0 : data.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (shopCategoryList_v1_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCard, {
                                    data: category,
                                    parent: parent
                                })
                            }, category.id))
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 95051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ShopList; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./containers/shopList/shopList.module.scss
var shopList_module = __webpack_require__(88090);
var shopList_module_default = /*#__PURE__*/__webpack_require__.n(shopList_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(9120);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(53048);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(52709);
// EXTERNAL MODULE: ./components/shopCard/shopCard.module.scss
var shopCard_module = __webpack_require__(79059);
var shopCard_module_default = /*#__PURE__*/__webpack_require__.n(shopCard_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/shopLogo/shopLogo.module.scss
var shopLogo_module = __webpack_require__(66944);
var shopLogo_module_default = /*#__PURE__*/__webpack_require__.n(shopLogo_module);
// EXTERNAL MODULE: ./utils/getImage.ts
var getImage = __webpack_require__(7592);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(25627);
;// CONCATENATED MODULE: ./components/shopLogo/shopLogo.tsx





function ShopLogo(param) {
    let { data  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (shopLogo_module_default()).logo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
            fill: true,
            src: (0,getImage/* default */.Z)(data.logo_img),
            alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
            sizes: "60px",
            quality: 90
        })
    });
}

// EXTERNAL MODULE: ./containers/shopBadges/shopBadges.module.scss
var shopBadges_module = __webpack_require__(97950);
var shopBadges_module_default = /*#__PURE__*/__webpack_require__.n(shopBadges_module);
// EXTERNAL MODULE: ./components/badge/badge.tsx
var badge = __webpack_require__(83764);
;// CONCATENATED MODULE: ./containers/shopBadges/shopBadges.tsx




function ShopBadges(param) {
    let { data  } = param;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shopBadges_module_default()).badge,
        children: [
            data.is_recommended && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "popular",
                variant: !!((ref = data.discount) === null || ref === void 0 ? void 0 : ref.length) || !!data.bonus ? "circle" : "default",
                size: "large"
            }),
            !!((ref1 = data.discount) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "discount",
                variant: data.is_recommended || !!data.bonus ? "circle" : "default",
                size: "large"
            }),
            !!data.bonus && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "bonus",
                variant: data.is_recommended || !!((ref2 = data.discount) === null || ref2 === void 0 ? void 0 : ref2.length) ? "circle" : "default",
                size: "large"
            })
        ]
    });
}

// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(46405);
// EXTERNAL MODULE: ./hooks/useShopWorkingSchedule.tsx
var useShopWorkingSchedule = __webpack_require__(40079);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(17312);
;// CONCATENATED MODULE: ./components/verifiedComponent/verifiedComponent.tsx


function VerifiedComponent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: {
            display: "block",
            minWidth: "16px",
            height: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* VerifiedIcon */.SA, {})
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(54017);
;// CONCATENATED MODULE: ./components/shopCard/shopCard.tsx











function ShopCard(param) {
    let { data  } = param;
    var ref, ref1;
    const { t  } = (0,useLocale/* default */.Z)();
    const { isShopClosed , workingSchedule  } = (0,useShopWorkingSchedule/* default */.Z)(data);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "/shop/".concat(data.id),
        className: "".concat((shopCard_module_default()).wrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopCard_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                    fill: true,
                    src: (0,getImage/* default */.Z)(data.background_img),
                    alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    sizes: "400px",
                    quality: 90
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopCard_module_default()).shopLogo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopLogo, {
                    data: data
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shopCard_module_default()).body,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopBadges, {
                        data: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shopCard_module_default()).titleContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "".concat((shopCard_module_default()).title, " ").concat(!(data === null || data === void 0 ? void 0 : data.verify) && (shopCard_module_default()).maxWidth),
                                children: (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                            }),
                            !!(data === null || data === void 0 ? void 0 : data.verify) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedComponent, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (shopCard_module_default()).text,
                        children: !isShopClosed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                workingSchedule === null || workingSchedule === void 0 ? void 0 : workingSchedule.from,
                                " - ",
                                workingSchedule === null || workingSchedule === void 0 ? void 0 : workingSchedule.to
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("closed")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shopCard_module_default()).rating,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                value: (data === null || data === void 0 ? void 0 : data.r_avg) || 0,
                                readOnly: true,
                                size: "small",
                                precision: 0.5,
                                name: "ratingIcon",
                                color: "var(--orange)",
                                className: (shopCard_module_default()).ratingIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (shopCard_module_default()).ratingCount,
                                children: (data === null || data === void 0 ? void 0 : data.r_count) || 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./components/button/load-more.tsx
var load_more = __webpack_require__(763);
// EXTERNAL MODULE: ./components/empty/empty.tsx
var empty = __webpack_require__(9956);
;// CONCATENATED MODULE: ./containers/shopList/shopList.tsx








function ShopList(param) {
    let { title , shops , loading , fetchNextPage , hasNextPage =false , fetchingNextPage =false  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1140px)");
    const handleLoadNexPage = ()=>{
        if (hasNextPage && fetchNextPage) {
            fetchNextPage();
        }
    };
    if (!loading && !(shops === null || shops === void 0 ? void 0 : shops.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(empty["default"], {
            text: t("no.shops.found")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (shopList_module_default()).container,
        style: {
            display: !loading && shops.length === 0 ? "none" : "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shopList_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (shopList_module_default()).title,
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: isDesktop ? 4 : 2,
                    children: !loading ? shops.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopCard, {
                                data: item
                            })
                        }, item.id)) : Array.from(new Array(4)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rectangular",
                                className: (shopList_module_default()).shimmer
                            })
                        }, "shops" + idx))
                }),
                hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).loadMore,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(load_more/* default */.Z, {
                        loading: fetchingNextPage,
                        onClick: handleLoadNexPage,
                        children: t("load.more")
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 68864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

function useModal() {
    let isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen);
    const handleOpen = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setOpen(true);
    };
    const handleClose = ()=>setOpen(false);
    return [
        open,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 40079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShopWorkingSchedule; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51218);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_weekdays__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85794);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28719);




function useShopWorkingSchedule(data) {
    const { order  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.order);
    const { workingSchedule , isShopClosed , isOpen , isTodayDisabled  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var ref, ref1;
        const isSelectedDeliveryDate = order.shop_id === (data === null || data === void 0 ? void 0 : data.id) && !!order.delivery_date;
        const today = isSelectedDeliveryDate ? order.delivery_date : dayjs__WEBPACK_IMPORTED_MODULE_1___default()().format("YYYY-MM-DD");
        const weekDay = constants_weekdays__WEBPACK_IMPORTED_MODULE_3__/* .WEEK */ .p[isSelectedDeliveryDate ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(order.delivery_date).day() : dayjs__WEBPACK_IMPORTED_MODULE_1___default()().day()];
        const foundedSchedule = data === null || data === void 0 ? void 0 : (ref = data.shop_working_days) === null || ref === void 0 ? void 0 : ref.find((item)=>item.day === weekDay);
        const isHoliday = data === null || data === void 0 ? void 0 : (ref1 = data.shop_closed_date) === null || ref1 === void 0 ? void 0 : ref1.some((item)=>dayjs__WEBPACK_IMPORTED_MODULE_1___default()(item.day).isSame(isSelectedDeliveryDate ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(order.delivery_date) : dayjs__WEBPACK_IMPORTED_MODULE_1___default()()));
        const isClosed = !(data === null || data === void 0 ? void 0 : data.open) || isHoliday;
        let schedule = {};
        let isTimePassed = false;
        let isTimeDidNotStart = false;
        try {
            if (foundedSchedule) {
                schedule = {
                    ...foundedSchedule
                };
                schedule.from = schedule.from.replace("-", ":");
                schedule.to = schedule.to.replace("-", ":");
                isTimePassed = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().isAfter("".concat(today, " ").concat(schedule.to));
                isTimeDidNotStart = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().isBefore("".concat(today, " ").concat(schedule.from));
            }
        } catch (err) {
            console.log("err => ", err);
        }
        return {
            workingSchedule: schedule,
            isShopClosed: schedule.disabled || isClosed || isTimePassed || isTimeDidNotStart,
            isOpen: Boolean(data === null || data === void 0 ? void 0 : data.open),
            isTodayDisabled: schedule.disabled
        };
    }, [
        data,
        order.delivery_date,
        order.shop_id
    ]);
    return {
        workingSchedule,
        isShopClosed,
        isOpen,
        isTodayDisabled
    };
}


/***/ }),

/***/ 52664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUserLocation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8854);


function useUserLocation() {
    const { location: userLocation  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__/* .useSettings */ .r)();
    const location = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const latlng = userLocation;
        if (!latlng) {
            return undefined;
        }
        return {
            latitude: latlng.split(",")[0],
            longitude: latlng.split(",")[1]
        };
    }, [
        userLocation
    ]);
    return location;
}


/***/ }),

/***/ 77490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomePage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(10299);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var es = __webpack_require__(49532);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var dist_es = __webpack_require__(53218);
// EXTERNAL MODULE: ./services/shop.ts
var shop = __webpack_require__(67788);
// EXTERNAL MODULE: ./services/category.ts
var category = __webpack_require__(21243);
// EXTERNAL MODULE: ./services/banner.ts
var banner = __webpack_require__(78610);
// EXTERNAL MODULE: ./hooks/useUserLocation.tsx
var useUserLocation = __webpack_require__(52664);
// EXTERNAL MODULE: ./node_modules/.pnpm/qs@6.15.1/node_modules/qs/lib/index.js
var lib = __webpack_require__(89834);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(21867);
// EXTERNAL MODULE: ./containers/homev1/homev1.module.scss
var homev1_module = __webpack_require__(86358);
var homev1_module_default = /*#__PURE__*/__webpack_require__.n(homev1_module);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(77712);
// EXTERNAL MODULE: ./containers/banner/banner.module.scss
var banner_module = __webpack_require__(15197);
var banner_module_default = /*#__PURE__*/__webpack_require__.n(banner_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(59164);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/bannerSingle/bannerSingle.module.scss
var bannerSingle_module = __webpack_require__(17699);
var bannerSingle_module_default = /*#__PURE__*/__webpack_require__.n(bannerSingle_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/image.js
var next_image = __webpack_require__(86430);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/bannerSingle/bannerSingle.tsx




function BannerSingle(param) {
    let { data  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/promotion/".concat(data.id),
        className: (bannerSingle_module_default()).banner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (bannerSingle_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                fill: true,
                priority: true,
                src: data === null || data === void 0 ? void 0 : data.img,
                alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                quality: 90,
                sizes: "(max-width: 376px) 340px, (max-width: 568px) 550px, (768px) 740px, (max-width: 992px) 960px, (max-width:1200px) 1160px, 1440px"
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/ArrowRightSLineIcon.js
var ArrowRightSLineIcon = __webpack_require__(19457);
var ArrowRightSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightSLineIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/ArrowLeftSLineIcon.js
var ArrowLeftSLineIcon = __webpack_require__(74540);
var ArrowLeftSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftSLineIcon);
// EXTERNAL MODULE: ./components/carouselArrows/carouselArrows.module.scss
var carouselArrows_module = __webpack_require__(46725);
var carouselArrows_module_default = /*#__PURE__*/__webpack_require__.n(carouselArrows_module);
;// CONCATENATED MODULE: ./components/carouselArrows/carouselArrows.tsx






function NextButton() {
    const swiper = (0,swiper_react/* useSwiper */.oc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((carouselArrows_module_default()).btn, " ").concat((carouselArrows_module_default()).next),
        onClick: ()=>swiper.slideNext(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightSLineIcon_default()), {})
    });
}
function PrevButton() {
    const swiper = (0,swiper_react/* useSwiper */.oc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((carouselArrows_module_default()).btn, " ").concat((carouselArrows_module_default()).prev),
        onClick: ()=>swiper.slidePrev(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftSLineIcon_default()), {})
    });
}


// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(52709);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(67222);
;// CONCATENATED MODULE: ./containers/banner/banner.tsx







function BannerContainer(param) {
    let { banners , loadingBanner  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (banner_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (banner_module_default()).banner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (banner_module_default()).bannerContainer,
                children: !loadingBanner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    spaceBetween: 10,
                    slidesPerView: 1,
                    children: [
                        banners.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSingle, {
                                    data: item
                                })
                            }, item.id)),
                        banners.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevButton, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {})
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (banner_module_default()).shimmerContainer,
                    children: Array.from(new Array(1)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "rectangular",
                            className: (banner_module_default()).shimmer
                        }, "banner" + idx))
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./components/button/primaryButton.tsx
var primaryButton = __webpack_require__(791);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/MapPinRangeFillIcon.js
var MapPinRangeFillIcon = __webpack_require__(36419);
var MapPinRangeFillIcon_default = /*#__PURE__*/__webpack_require__.n(MapPinRangeFillIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(34131);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/home-actions/home-actions.module.scss
var home_actions_module = __webpack_require__(9514);
var home_actions_module_default = /*#__PURE__*/__webpack_require__.n(home_actions_module);
;// CONCATENATED MODULE: ./components/home-actions/home-actions.tsx







const HomeFilter = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6189).then(__webpack_require__.bind(__webpack_require__, 56189)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56189)
            ]
    }
});
function HomeActions() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const { push  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (home_actions_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeFilter, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (home_actions_module_default()).viewInMap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((MapPinRangeFillIcon_default()), {
                        size: 20
                    }),
                    fullWidth: false,
                    onClick: ()=>push("/shops-in-map"),
                    rounded: false,
                    children: t("view.in.map")
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./containers/shopList/shopList.tsx + 4 modules
var shopList = __webpack_require__(95051);
// EXTERNAL MODULE: ./containers/shopCategoryList/v1.tsx + 1 modules
var v1 = __webpack_require__(93696);
;// CONCATENATED MODULE: ./components/grocery/grocery-data.ts
// export const groceryData = [
//   {
//     id: "01",
//     title: "Build Your Order",
//     description: "Customize your box & set a schedule of recurring deliveries",
//   },
//   {
//     id: "02",
//     title: "Save Even More",
//     description: "Get extra 5-10% off thousands of products an Autoship",
//   },
//   {
//     id: "03",
//     title: "You’re In Control",
//     description:
//       "Edit items, skip or pause Autoship, or place one-time orders anytime",
//   },
// ];
const groceryData = [
    {
        id: "01",
        title: "Monte seu pedido de compra",
        description: "Personalize sua comprar e conta\xe7\xf5es de forma autom\xe1tica e defina um cronograma de entregas recorrentes"
    },
    {
        id: "02",
        title: "Economize ainda mais",
        description: "Economize em milhares de produtos no envio autom\xe1tico e agilize seu processo de compra e cota\xe7\xf5es autom\xe1ticas"
    },
    {
        id: "03",
        title: "Voc\xea no controle",
        description: "Edite itens, pule ou pause o envio autom\xe1tico, ou fa\xe7a pedidos avulsos a qualquer momento"
    }
];

// EXTERNAL MODULE: ./components/grocery/grocery.module.scss
var grocery_module = __webpack_require__(30095);
var grocery_module_default = /*#__PURE__*/__webpack_require__.n(grocery_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(9120);
;// CONCATENATED MODULE: ./components/grocery/grocery.tsx







function Grocery() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1024px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (grocery_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (grocery_module_default()).containerTitle,
                children: t("groceries.delivered.on.your.schedule")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (grocery_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    breakpoints: {
                        0: {
                            slidesPerView: 1
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    },
                    children: groceryData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: index === 1 && isDesktop ? (grocery_module_default()).sideBorder : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (grocery_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: (grocery_module_default()).number,
                                        children: item.id
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (grocery_module_default()).title,
                                        children: t(item.title)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (grocery_module_default()).description,
                                        children: t(item.description)
                                    })
                                ]
                            })
                        }, item.id))
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/becomeSellerBanner/becomeSellerBanner.module.scss
var becomeSellerBanner_module = __webpack_require__(67511);
var becomeSellerBanner_module_default = /*#__PURE__*/__webpack_require__.n(becomeSellerBanner_module);
;// CONCATENATED MODULE: ./components/becomeSellerBanner/becomeSellerBanner.tsx





function BecomeSellerBanner() {
    const { t  } = (0,dist_es/* useTranslation */.$G)();
    const { push  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (becomeSellerBanner_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (becomeSellerBanner_module_default()).textWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (becomeSellerBanner_module_default()).title,
                    children: t("become.seller.home.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (becomeSellerBanner_module_default()).description,
                    children: t("become.seller.home.description")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton/* default */.Z, {
                    fullWidth: false,
                    size: "large",
                    onClick: ()=>push("/be-seller"),
                    children: t("become.seller.home.button")
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(68864);
// EXTERNAL MODULE: ./constants/config.ts
var config = __webpack_require__(66750);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(8854);
// EXTERNAL MODULE: ./services/recipe.ts
var recipe = __webpack_require__(92173);
;// CONCATENATED MODULE: ./containers/homev1/homev1.tsx























const MobileSearchContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9134), __webpack_require__.e(6101), __webpack_require__.e(7056), __webpack_require__.e(1271)]).then(__webpack_require__.bind(__webpack_require__, 57056)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57056)
            ]
    }
});
const VisitedShops = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9762).then(__webpack_require__.bind(__webpack_require__, 79762)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(79762)
            ]
    }
});
function Home() {
    var ref, ref1, ref2;
    const { t , i18n  } = (0,dist_es/* useTranslation */.$G)();
    const { query  } = (0,router.useRouter)();
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 1140px)");
    const locale = i18n.language;
    const { isAuthenticated  } = (0,auth_context/* useAuth */.a)();
    const { settings  } = (0,settings_context/* useSettings */.r)();
    const location = (0,useUserLocation/* default */.Z)();
    const [searchModal, handleOpenSearchModal, handleCloseSearchModal] = (0,useModal/* default */.Z)();
    const { data: shopCategoryList , isLoading: shopCategoryLoading  } = (0,es.useQuery)([
        "shopCategory",
        locale
    ], ()=>category/* default.getAllShopCategories */.Z.getAllShopCategories({
            perPage: 20
        }));
    const { data: banners , isLoading: isBannerLoading  } = (0,es.useQuery)([
        "banners",
        locale
    ], ()=>banner/* default.getAll */.Z.getAll());
    const shopParams = {
        category_id: (query === null || query === void 0 ? void 0 : query.category_id) || undefined,
        address: location,
        open: (query === null || query === void 0 ? void 0 : query.open) || undefined,
        column: (query === null || query === void 0 ? void 0 : query.column) || undefined,
        sort: (query === null || query === void 0 ? void 0 : query.sort) || undefined,
        work_24_7: (query === null || query === void 0 ? void 0 : query.work_24_7) || undefined
    };
    const { data , fetchNextPage , hasNextPage , isFetchingNextPage , isLoading  } = (0,es.useInfiniteQuery)([
        "restaurants",
        locale,
        location,
        query === null || query === void 0 ? void 0 : query.column,
        query === null || query === void 0 ? void 0 : query.sort,
        query === null || query === void 0 ? void 0 : query.open,
        query === null || query === void 0 ? void 0 : query.work_24_7,
        query === null || query === void 0 ? void 0 : query.category_id
    ], (param)=>{
        let { pageParam =1  } = param;
        return shop/* default.getAllRestaurants */.Z.getAllRestaurants(lib_default().stringify({
            page: pageParam,
            perPage: 8,
            ...shopParams
        }));
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        }
    });
    const { data: visitedShops  } = (0,es.useQuery)({
        queryKey: [
            "visitedShops",
            locale,
            isAuthenticated
        ],
        queryFn: ()=>shop/* default.getVisitedShops */.Z.getVisitedShops({
                perPage: 10,
                page: 1
            }),
        staleTime: 0
    });
    const { data: recipes , isLoading: isRecipesLoading  } = (0,es.useQuery)({
        queryKey: [
            "recipes",
            locale,
            shopParams === null || shopParams === void 0 ? void 0 : shopParams.category_id
        ],
        queryFn: ()=>{
            return recipe/* default.getAll */.Z.getAll({
                perPage: 10,
                category_id: shopParams === null || shopParams === void 0 ? void 0 : shopParams.category_id
            });
        }
    });
    const restaurants = (data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>item.data)) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (homev1_module_default()).search,
                    onClick: handleOpenSearchModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(t("search.on"), " ").concat((settings === null || settings === void 0 ? void 0 : settings.title) || config/* META_TITLE */.k5)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).bannerContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                        banners: (banners === null || banners === void 0 ? void 0 : banners.data) || [],
                        loadingBanner: isBannerLoading
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).homeActionContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeActions, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).shopCategoryListContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1["default"], {
                        data: (shopCategoryList === null || shopCategoryList === void 0 ? void 0 : (ref1 = shopCategoryList.data) === null || ref1 === void 0 ? void 0 : ref1.sort((a, b)=>{
                            return (a === null || a === void 0 ? void 0 : a.input) - (b === null || b === void 0 ? void 0 : b.input);
                        })) || [],
                        loading: shopCategoryLoading
                    })
                })
            }),
            !!(visitedShops === null || visitedShops === void 0 ? void 0 : (ref2 = visitedShops.data) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisitedShops, {
                        data: visitedShops === null || visitedShops === void 0 ? void 0 : visitedShops.data
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).shopListContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shopList["default"], {
                        title: t("all.shops"),
                        shops: restaurants,
                        loading: isLoading && !isFetchingNextPage,
                        hasNextPage: hasNextPage,
                        fetchNextPage: fetchNextPage,
                        fetchingNextPage: isFetchingNextPage
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).groceryContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grocery, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homev1_module_default()).becomeSellerContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomeSellerBanner, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearchContainer, {
                open: searchModal,
                onClose: handleCloseSearchModal,
                fullScreen: true
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/index.tsx



function HomePage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {})
        ]
    });
}


/***/ }),

/***/ 78610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const bannerService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners/paginate", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners/".concat(id), {
            params
        }),
    getAllAds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners-ads", {
            params
        }),
    getAdById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/banners-ads/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (bannerService);


/***/ }),

/***/ 21243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const categoryService = {
    getAllShopCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "shop"
            }
        });
    },
    getAllSubCategories: function(categoryId) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("rest/categories/sub-shop/".concat(categoryId), {
            params
        });
    },
    getAllProductCategories: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/categories"), {
            params
        }),
    getAllRecipeCategories: function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/paginate", {
            params: {
                ...params,
                type: "receipt"
            }
        });
    },
    getById: function(id) {
        let params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return _request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/categories/".concat(id), {
            params
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (categoryService);


/***/ }),

/***/ 92173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const recipeService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/receipts/paginate", {
            params
        }),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/receipts/".concat(id), {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (recipeService);


/***/ }),

/***/ 67788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const shopService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?".concat(params)),
    getAllBooking: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/booking/shops/paginate?".concat(params)),
    getAllRestaurants: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?type=restaurant&".concat(params)),
    getAllShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?type=shop&".concat(params)),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/search", {
            params
        }),
    getAllTags: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-takes", {
            params
        }),
    create: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/dashboard/user/shops", data),
    checkZone: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/delivery-zone/check/distance", {
            params
        }),
    checkZoneById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/".concat(id, "/delivery-zone/check/distance"), {
            params
        }),
    getVisitedShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-histories/paginate", {
            params
        }),
    getByIds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/ids", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (shopService);


/***/ }),

/***/ 7592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getImage; }
/* harmony export */ });
// import { IMAGE_URL } from "constants/constants";
function getImage(img) {
    if (img) {
        return img;
    } else {
        return "";
    }
}


/***/ }),

/***/ 30730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__BHeKC","default":"badge_default__18BvY","circle":"badge_circle__mQVZ_","text":"badge_text__cdsyf","large":"badge_large__bhCOW","medium":"badge_medium__3BTPx","bonus":"badge_bonus__Ice67","discount":"badge_discount__gVAeQ","popular":"badge_popular__ywwJB"};

/***/ }),

/***/ 17699:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"bannerSingle_banner__kN2kr","wrapper":"bannerSingle_wrapper__xyQZd"};

/***/ }),

/***/ 67511:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"becomeSellerBanner_container___o7cf","textWrapper":"becomeSellerBanner_textWrapper__iLlPa","title":"becomeSellerBanner_title__CpkMA","description":"becomeSellerBanner_description__6UF8q","imageWrapper":"becomeSellerBanner_imageWrapper__Z2E4L"};

/***/ }),

/***/ 46725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"carouselArrows_btn__5gqN5","next":"carouselArrows_next__d5Bj1","prev":"carouselArrows_prev__LrJLV"};

/***/ }),

/***/ 14363:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"v1_card__vZ8Zq","active":"v1_active___1OE2","img":"v1_img__Pkq7P","text":"v1_text___e43I"};

/***/ }),

/***/ 55684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"empty_wrapper__nwTin","text":"empty_text__oRHIv","actions":"empty_actions__NNcWA"};

/***/ }),

/***/ 79963:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 30095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"grocery_container__NZo1q","containerTitle":"grocery_containerTitle__M7vLB","wrapper":"grocery_wrapper__Ql6QM","swiperSlider":"grocery_swiperSlider__egpZm","item":"grocery_item__VqKrj","number":"grocery_number__M5DyR","title":"grocery_title__31Teo","description":"grocery_description__yagGt","sideBorder":"grocery_sideBorder__5Ee8U"};

/***/ }),

/***/ 9514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"home-actions_container__i_pCP","viewInMap":"home-actions_viewInMap__uk5ey"};

/***/ }),

/***/ 79059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shopCard_wrapper__eLDR6","header":"shopCard_header__ndTnF","shopLogo":"shopCard_shopLogo__YBVUk","body":"shopCard_body__RaioU","titleContainer":"shopCard_titleContainer__PoAO_","title":"shopCard_title__ZOeFL","maxWidth":"shopCard_maxWidth__hzAq9","text":"shopCard_text__N8BjM","rating":"shopCard_rating__e7b0N","ratingIcon":"shopCard_ratingIcon___i8oO","ratingCount":"shopCard_ratingCount__okJy2"};

/***/ }),

/***/ 66944:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"shopLogo_logo__RFCaX"};

/***/ }),

/***/ 15197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__ZEunx","banner":"banner_banner__D8D5Q","bannerContainer":"banner_bannerContainer__E7T_G","shimmerContainer":"banner_shimmerContainer__hKSIU","shimmer":"banner_shimmer__tp1rt"};

/***/ }),

/***/ 86358:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"homev1_search__bYQIC","bannerContainer":"homev1_bannerContainer__K7ekR","homeActionContainer":"homev1_homeActionContainer__yXAfW","shopCategoryListContainer":"homev1_shopCategoryListContainer__HIWQx","shopListContainer":"homev1_shopListContainer__P4ovs","recipeListContainer":"homev1_recipeListContainer__Sl1CH","groceryContainer":"homev1_groceryContainer__po3Ay","inviteFriendContainer":"homev1_inviteFriendContainer__DZcDX","becomeSellerContainer":"homev1_becomeSellerContainer__nn93L"};

/***/ }),

/***/ 97950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"shopBadges_badge__NpYKe"};

/***/ }),

/***/ 36956:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"v1_container__4DKRy","title":"v1_title__S4qxw","swiperSlide":"v1_swiperSlide__yiAEb","shimmer":"v1_shimmer__pFUE9","card":"v1_card__dr1_z","active":"v1_active__94rQb","text":"v1_text__aeMs_"};

/***/ }),

/***/ 88090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shopList_container__dXd4J","wrapper":"shopList_wrapper__q4bQb","header":"shopList_header__8uPMd","title":"shopList_title__D3BSf","loadMore":"shopList_loadMore__xxuRm","shimmer":"shopList_shimmer__tOM85"};

/***/ }),

/***/ 74540:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowLeftSLineIcon = function ArrowLeftSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z' })
  );
};

var ArrowLeftSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowLeftSLineIcon) : ArrowLeftSLineIcon;

module.exports = ArrowLeftSLineIcon$1;


/***/ }),

/***/ 19457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightSLineIcon = function ArrowRightSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z' })
  );
};

var ArrowRightSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightSLineIcon) : ArrowRightSLineIcon;

module.exports = ArrowRightSLineIcon$1;


/***/ }),

/***/ 36419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var MapPinRangeFillIcon = function MapPinRangeFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938v2.074c3.946.092 7 .723 7 1.488 0 .828-3.582 1.5-8 1.5s-8-.672-8-1.5c0-.765 3.054-1.396 7-1.488v-2.074zM12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z' })
  );
};

var MapPinRangeFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(MapPinRangeFillIcon) : MapPinRangeFillIcon;

module.exports = MapPinRangeFillIcon$1;


/***/ }),

/***/ 71568:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2709,9164,7876,2426,9774,2888,179], function() { return __webpack_exec__(16726); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);